var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { display: "flex" } }, [
    _c(
      "div",
      {
        staticClass: "main-content",
        staticStyle: { width: "80%" },
        style: _vm.mainContentViewHeight,
      },
      [
        _vm.customFormShow
          ? _c("customForm", {
              ref: "customFormRef",
              attrs: { baseURL: _vm.baseURL },
              on: {
                "update:baseURL": function ($event) {
                  _vm.baseURL = $event
                },
                "update:base-u-r-l": function ($event) {
                  _vm.baseURL = $event
                },
              },
            })
          : _vm._e(),
        _vm.customFormOtherShow
          ? _c("customFormOther", {
              ref: "customFormOtherRef",
              attrs: { nodeCode: "GC00014" },
            })
          : _vm._e(),
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("附件列表")])]
            ),
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { stripe: "", data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "姓名", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "地址" },
                  }),
                ],
                1
              ),
            ],
          ],
          2
        ),
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("数据监督记录(审批信息)")])]
            ),
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { stripe: "", data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "日期", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "姓名", width: "180" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "address", label: "地址" },
                  }),
                ],
                1
              ),
            ],
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "el-card box-card is-always-shadow",
        staticStyle: { margin: "0 10px 0 10px", width: "20%", height: "auto" },
      },
      [
        _c(
          "div",
          { staticStyle: { "text-align": "center", margin: "10px 0 3px 0" } },
          [
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.getFlowNode(0)
                  },
                },
              },
              [
                _c("icon-svg", {
                  staticClass: "site-sidebar__menu-icon",
                  attrs: { name: "zonghe" },
                }),
              ],
              1
            ),
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.getFlowNode(1)
                  },
                },
              },
              [
                _c("icon-svg", {
                  staticClass: "site-sidebar__menu-icon",
                  attrs: { name: "menu" },
                }),
              ],
              1
            ),
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.getFlowNode(2)
                  },
                },
              },
              [
                _c("icon-svg", {
                  staticClass: "site-sidebar__menu-icon",
                  attrs: { name: "admin" },
                }),
              ],
              1
            ),
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.getFlowNode(3)
                  },
                },
              },
              [
                _c("icon-svg", {
                  staticClass: "site-sidebar__menu-icon",
                  attrs: { name: "log" },
                }),
              ],
              1
            ),
            _c(
              "span",
              {
                on: {
                  click: function ($event) {
                    return _vm.getFlowNode(4)
                  },
                },
              },
              [
                _c("icon-svg", {
                  staticClass: "site-sidebar__menu-icon",
                  attrs: { name: "role" },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._l(_vm.flowData, function (value, key) {
          return _c("div", { key: key }, [
            _c(
              "table",
              {
                staticStyle: {
                  border: "1px solid #6e6d6d",
                  "border-collapse": "collapse",
                  "text-align": "center",
                },
              },
              [
                _c(
                  "tr",
                  {
                    staticStyle: {
                      height: "25px",
                      background: "#0259a8",
                      color: "white",
                    },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          border: "1px solid #6e6d6d",
                          width: "300px",
                        },
                      },
                      [_vm._v(_vm._s(key))]
                    ),
                  ]
                ),
                _vm._l(value, function (item) {
                  return _c(
                    "tr",
                    { key: item.id, staticStyle: { height: "25px" } },
                    [
                      item.isVisible
                        ? _c(
                            "td",
                            {
                              staticClass: "link",
                              staticStyle: {
                                border: "1px solid #6e6d6d",
                                width: "300px",
                                color: "#005aff",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getFormContent(item.formId)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.nodeName))]
                          )
                        : _c(
                            "td",
                            {
                              staticStyle: {
                                border: "1px solid #6e6d6d",
                                width: "300px",
                                color: "#8b8c9b",
                              },
                            },
                            [_vm._v(_vm._s(item.nodeName))]
                          ),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }